<div [ngStyle]="{
    'display': 'inline-block',
    'min-width': '300px',
    'width': '100%',
  }">
<app-dynamic-table [schema]="schema" [modalfieldConfig]="fieldConfig" [total]="total" [data]="list" (changeEvent)="change($event)" (actionEvent)="formEvent($event)"></app-dynamic-table>
</div>
